import { IdtComponent } from 'shared/models/idt-components/idt-component.models';


export function getWysiwygAligmentClasses(component: IdtComponent | undefined) {
  const classes: string[] = [];

  if (isDefined(component) && isDefined(component.settings)) {
    if (component.settings?.general?.typetext) {
      classes.push(component.settings.general.typetext);
    }

    if (component.settings?.styles?.textPositionVertical) {
      classes.push(`vertical-${component.settings.styles.textPositionVertical}`);
    }

    if (component.settings?.general?.shadow) {
      classes.push(component.settings.general.shadow);
    }
  }

  return classes.join(' ');
}
